<template>
  <b-modal
    id="disclaimer-modal"
    :title="$t('label.terms.conditions')"
    size="xl"
    header-class="p-modal-header"
    modal-class="p-modal"
    :hide-footer="true"
    :no-close-on-backdrop="!hideHeaderClose"
    :no-close-on-esc="!hideHeaderClose"
    :hide-header-close="!hideHeaderClose"
  >
    <template>
      <div class="m-2 toggle-separator" />
      <PRow>
        <PCol class="disclaimer-content">
          <embed
            id="disclaimer-pdf"
            :src="'data:application/pdf;base64,' + getDisclaimer"
            type="application/pdf"
            v-if="getDisclaimer"
          />
        </PCol>
      </PRow>
      <div class="m-2 toggle-separator" />
      <PRow>
        <PCol>
          <PFormSwitch
            :label="$t('label.terms.conditions.description')"
            v-model="getLoggedUser.acceptDisclaimer"
            @change="onUpdateAcceptDisclaimer"
            v-if="!getLoggedUser.acceptDisclaimer"
          >
          </PFormSwitch>
        </PCol>
      </PRow>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import VueFilters from "@/vue-filters";
import { Getter } from "vuex-class";
import { IUsuarioUpdateDisclaimer } from "@/services";
import { IUsuario } from "@/entities";

@Component({
  name: "disclaimer-modal",
  components: { VueFilters },
})
export default class DisclaimerModal extends Vue {
  @Getter("getDisclaimer") getDisclaimer!: string;
  @Getter("getLoggedUser") getLoggedUser!: IUsuario;
  usuarioAcceptDisclaimer: IUsuarioUpdateDisclaimer = {
    acceptDisclaimer: true,
  };

  async mounted(): Promise<void> {
    if (this.getDisclaimer && !this.getLoggedUser.acceptDisclaimer) {
      this.openDisclaimerModal();
    }
  }

  get hideHeaderClose(): boolean | undefined {
    return this.getLoggedUser?.acceptDisclaimer;
  }

  async onUpdateAcceptDisclaimer(): Promise<void> {
    this.usuarioAcceptDisclaimer.acceptDisclaimer = this.getLoggedUser.acceptDisclaimer;

    await this.$services.usuarios.updateAcceptDisclaimer(this.usuarioAcceptDisclaimer);
  }

  openDisclaimerModal(): void {
    return this.$bvModal.show("disclaimer-modal");
  }
}
</script>
<style lang="scss" scoped>
#disclaimer-pdf {
  width: 100%;
  height: 100%;
}
.disclaimer-content {
  height: 65vh;
  min-height: 700px;
}
@media (max-width: 768px) {
  .disclaimer-content {
    min-height: auto;
  }
}
</style>
